import { createElement, ReactNode } from "react";

// types
import { DELIVERY_SECTION_ELEMENT, isToingFlow } from "@swiggy-private/checkout-core";

// components
import { DeliveryTypeTabFtueNewTag } from "@cart-client/components/delivery-type-tab-ftue-new-tag/DeliveryTypeTabFtueNewTag";

export const getDeliveryTabRightIcon = (type: DELIVERY_SECTION_ELEMENT): ReactNode => {
    if (type !== DELIVERY_SECTION_ELEMENT.DELIVERY_TYPE) {
        return null;
    }

    if (!isToingFlow()) {
        return null;
    }

    return createElement(DeliveryTypeTabFtueNewTag);
};
